import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"380\" height=\"500\" class=\"errorSvg\" viewBox=\"0 0 837 1045\"><g fill=\"none\" fill-rule=\"evenodd\"><path stroke=\"#007FB2\" stroke-width=\"6\" d=\"m353 9 274 161v317L353 642 79 487V170L353 9Z\" class=\"errorSvgPath1\"></path><path stroke=\"#EF4A5B\" stroke-width=\"6\" d=\"m79 529 68 40v79l-68 39-69-39v-79l69-40Z\" class=\"errorSvgPath2\"></path><path stroke=\"#795D9C\" stroke-width=\"6\" d=\"m773 186 54 32v62l-54 30-54-30v-62l54-32Z\" class=\"errorSvgPath3\"></path><path stroke=\"#F2773F\" stroke-width=\"6\" d=\"m639 529 134 79v155l-134 76-134-76V608l134-79Z\" class=\"errorSvgPath4\"></path><path stroke=\"#36B455\" stroke-width=\"6\" d=\"m281 801 102 60v118l-102 58-102-58V861l102-60Z\" class=\"errorSvgPath5\"></path></g></svg>", 1)
const _hoisted_2 = { class: "message-box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Error", -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "buttons-con" }
const _hoisted_6 = { class: "action-link-wrap" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("トップへ")
const _hoisted_8 = {
  key: 1,
  href: "/",
  class: "link-button link-back-button"
}

import { onUnmounted, computed } from 'vue'
import { useErrorStore } from '@/stores'
import { isDev } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const errorStore = useErrorStore()

onUnmounted(errorStore.reset)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, [
        _createElementVNode("span", {
          innerHTML: _unref(errorStore).message
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_unref(isDev))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/",
                class: "link-button link-back-button"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("a", _hoisted_8, "トップへ"))
        ])
      ])
    ])
  ]))
}
}

})